function kitDebounce(func, timeout = 50) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

class KitBuilderForm extends HTMLElement {
  constructor() {
    super();
    this.kitName = this.dataset.kitName;
    this.customerType = this.dataset.customerType;
    this.retailDiscount = this.dataset.retailDiscount;
    this.tradeDiscount = this.dataset.tradeDiscount;
    this.wholesaleDiscount = this.dataset.wholesaleDiscount;
    this.internalOrdering = this.dataset.internalOrdering;

    switch (this.customerType) {
      case 'retail':
        this.discount = this.retailDiscount;
        break;
      case 'trade':
        this.discount = this.tradeDiscount;
        break;
      case 'wholesale':
        this.discount = this.wholesaleDiscount;
        break;
    }

    this.priceElements = document.querySelectorAll(`.price__current [data-price]`);
    this.originalPriceElements = document.querySelectorAll(`.price__compare-at`);

    this.unitPriceElements = document.querySelectorAll(`.price__current.price-small [data-price]`);
    this.originalUnitPrices = document.querySelectorAll(`.price__compare-at.price-small`);
    
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.addToCartButton = this.querySelector('[data-add-to-cart]');
    
    this.meshScrewMultiplier = this.dataset.meshScrewMultiplier;
    this.saddleMultiplier = this.dataset.saddleMultiplier;
    this.saddleScrewMultiplier = this.dataset.saddleScrewMultiplier;
    this.trimMultiplier = 3.333333;
    this.trimScrewMultiplier = this.dataset.trimScrewMultiplier;

    this.meshPrice = parseInt(this.dataset.meshPrice);
    this.meshScrewPrice = parseInt(this.dataset.meshScrewPrice);
    this.saddlePrice = parseInt(this.dataset.saddlePrice);
    this.saddleScrewPrice = parseInt(this.dataset.saddleScrewPrice);
    this.trimPrice = parseInt(this.dataset.trimPrice);
    this.trimScrewPrice = parseInt(this.dataset.trimScrewPrice);

    this.meshSize = document.querySelector('product-mesh-size');
    this.saddleColor = document.querySelector('saddle-product-color');
    this.trimColor = document.querySelector('trim--product-color');

    this.meshId = this.dataset.meshId;
    this.saddleId = this.dataset.saddleId;
    this.saddleScrewId = this.dataset.saddleScrewId;
    this.trimId = this.dataset.trimId;
    this.trimScrewId = this.dataset.trimScrewId;
    
    this.components = {
      mesh: {
        unitSelector: '[data-mesh-unit]',
        cardSelector: '[data-mesh-product]',
        groupSelector: '[data-mesh-group]',
        qty: 0,
        id: this.meshId,
        price: this.meshPrice,
        type: 'mesh',
      },
      meshScrews: {
        unitSelector: '[data-mesh-screw-unit]',
        cardSelector: '[data-mesh-screw-product]',
        groupSelector: '[data-mesh-group]',
        matchMesh: true,
        qty: 0,
        id: 0,
        price: this.meshScrewPrice,
        screwType: "Mesh",
        type: 'screw',
      },
      saddles: {
        unitSelector: '[data-saddle-unit]',
        cardSelector: '[data-saddle-product]',
        groupSelector: '[data-saddle-group]',
        matchMesh: true,
        qty: 0,
        id: this.saddleId,
        price: this.saddlePrice,
        type: 'saddle',
      },
      saddleScrews: { 
        unitSelector: '[data-saddle-screw-unit]',
        cardSelector: '[data-saddle-screw-product]',
        groupSelector: '[data-saddle-group]',
        matchMesh: true,
        qty: 0,
        id: this.saddleScrewId,
        price: this.saddleScrewPrice,
        screwType: "Saddle",
        type: 'screw',
      },
      trim: {
        unitSelector: '[data-trim-unit]',
        cardSelector: '[data-trim-product]',
        groupSelector: '[data-trim-group]',
        matchMesh: true,
        qty: 0,
        id: this.trimId,
        price: this.trimPrice,
        type: 'trim',
      },
      trimScrews: {
        unitSelector: '[data-trim-screw-unit]',
        cardSelector: '[data-trim-screw-product]',
        groupSelector: '[data-trim-group]',
        matchMesh: true,
        qty: 0,
        id: this.trimScrewId,
        price: this.trimScrewPrice,
        screwType: "Trim",
        type: 'screw',
      }
    }
    this.init();
  }

  init() {
    this.activeSize = document.querySelector('[data-size-option].active');
    this.meshProductHandle = this.activeSize.dataset.productHandle;
    this.meshScrewHandle = this.querySelector('[data-type="mesh"]').dataset.screwHandle;

    this.unitPrice = parseInt(this.unitPriceElements[0].dataset.price);
    this.unitComparePrice = parseInt(this.originalUnitPrices[0].querySelector('[data-unit-price-regular]').dataset.price);
    this.discountValue = 1 - (this.discount / 100);
    this.unitPriceElements.forEach((el) => {
      el.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.unitPrice / 100.00).toFixed(2));
    });
    if(this.discount > 0) {
      this.originalUnitPrices.forEach((el) => {
        el.classList.add('visible');
        const regular = el.querySelector('[data-unit-price-regular]');
        if (regular) regular.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.unitComparePrice / 100.00).toFixed(2));
      });
    }
    
    
    this.saddles = this.querySelector('[data-type="saddles"]');
    if(this.saddles) {
      this.saddleHandle = this.saddles.dataset.productHandle;
      this.saddleScrewHandle = this.saddles.dataset.screwHandle;
    }

    this.trim = this.querySelector('[data-type="trim"]');
    if(this.trim) {
      this.trimHandle = this.trim.dataset.productHandle;
      this.trimScrewHandle = this.trim.dataset.screwHandle;

      this.activeType = document.querySelector('[data-type-option].active');
      this.meshProductHandle = this.activeSize.dataset.productHandle;
    }
    
    
    this.setProduct('mesh', 'handle', this.meshProductHandle);
    
    if(this.meshScrewHandle) this.setProduct('meshScrews', 'handle', this.meshScrewHandle);
    if(this.saddleHandle) this.setProduct('saddles', 'handle', this.saddleHandle);
    if(this.saddleScrewHandle) this.setProduct('saddleScrews', 'handle', this.saddleScrewHandle);
    if(this.trimHandle) this.setProduct('trim', 'handle', this.trimHandle);
    if(this.trimScrewHandle) this.setProduct('trimScrews', 'handle', this.trimScrewHandle);

    this.productTitle = this.activeSize.dataset.title;
    this.meshColor = document.querySelector('mesh-product-color');
    this.meshColor.querySelector('[data-title-placeholder]').innerText = this.productTitle;
    this.meshColor.dataset.productHandle = this.meshProductHandle;
    setTimeout(() => {
      this.classList.remove('loading');
    }, 1000);
    
    // don't need to set price on load as we don't have variants — this.handleQtyChange(this.quantityInput.value)
    // this.quantityInput.addEventListener('change', (event) => this._handleQtyChange(event));
  
    this.addToCartButton.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.quantityInput.value == 0) {
        this.querySelector('.quantity-selector__wrapper').focus();
      } else if (this.addToCartButton.getAttribute('custom-disable') === 'true') {
        return;
      } else  {
        this._handleAddToCart(e, this.addToCartButton)
      }
    })
  }

  handleQtyChange(qty) {
    this.qty = qty;
    this.components.mesh.qty = qty;
    this.components.trim.qty = Math.ceil(qty * this.trimMultiplier);
    this.components.saddles.qty = Math.ceil(qty * this.saddleMultiplier);
    this.components.saddleScrews.qty = Math.ceil(qty * this.saddleScrewMultiplier);
    this.components.trimScrews.qty = Math.ceil(qty * this.trimScrewMultiplier);
    this.components.meshScrews.qty = Math.ceil(qty * this.meshScrewMultiplier);
    this._updateTotalPrice();
    this._updateQuantityElements();
  }

  _updateQuantityElements() {
    Object.values(this.components).forEach((component) => {
      console.log(component.unitSelector)
      document.querySelectorAll(component.unitSelector).forEach((unit) => {
        unit.innerText = component.qty;
      })
    });
  }

  setProduct(product, key, value) {
    this.components[product][key] = value;
    // console.log(`Set by ${product}`, this.components)
    /*if(product == 'mesh') {
      Object.values(this.components).forEach((component) => {
        if(!component.color) {
          component.color = color;
        }
      });
    }*/
  }

  updateVariant(product, variantId, handle, color) {
    this.components[product].id = parseInt(variantId);
    this.components[product].handle = handle;
    if(product == 'mesh') {
      Object.values(this.components).forEach((component) => {
        if(!component.color) {
          if(color) {
            if(color === 'Dark Brown') {
              if(component.screwType == 'Mesh') {
                component.color = 'Loft';
                this.setIds(color, component);
              } else {
                component.color = 'Jasper';
                this.setIds(color, component);
              }
            } else if(color === 'Terracotta') {
              component.color = 'Terrain';
              this.setIds(color, component);
            } else if(color === 'Headland') {
              if(component.type == 'trim' || component.type == 'saddle' || component.screwType == 'Saddle' || component.screwType === 'Trim') {
                component.color = 'Manor Red';
                this.setIds(color, component);
              }
              
            }  else {
              component.color = color;
              this.setIds(color, component);
            }
          }
          
        }
      });
      this.components[product].color = color;

      //this.addToCartButton.classList.remove('disabled');
    } else {
      if(color) this.components[product].color = color;
    }
  }

  setIds(color, component) {
    
    if(component.handle){
      fetch(`/products/${component.handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
  
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
        this.product = this.productSettings.product;
        if(component.matchMesh === true) {
          this.variant = this.product.variants.find(variant => variant.title == component.color);
          component.id = this.variant.id;
        } else {
          this.variant = this.product.variants.find(variant => variant.id == component.id);
        }
        component.id = this.variant.id;
        if(this.variant) component.price = this.variant.price;

        this._updateProductCards(component.cardSelector, this.variant);
        this._updateTotalPrice();
      })
      .catch()
      document.querySelectorAll('.kit-product__swatch').forEach((swatch) => {
        swatch.classList.remove('placeholder');
        swatch.style.background = `var(--${component.color.replace(/\s/g, '')})`;
      })
      document.querySelectorAll('[data-option-color]').forEach((colorName) => {
        colorName.innerHTML = `${component.color.trim()}<sup>®</sup>`;
      })
    } 
  }

  fetchPreselectedColor(component) {
    if(this.components[component].color) {
      return this.components[component].color;
    } else {
      return false;
    }
  }

  _refreshPreorderMessaging() {
    const atcButton = document.querySelector('.atc-button--text');
    const elementKits = document.querySelector('.pre-OrdersMessage');
    const preOrderItems = document.querySelector('.activeme');
    if (atcButton) {
      if (preOrderItems) {
        atcButton.textContent = ' Pre-order ';
        if (elementKits) elementKits.style.display = 'block';
      } else {
        atcButton.textContent = ' Add to cart ';
        if (elementKits) elementKits.style.display = 'none';
      }
    }

    const kitDates = document.querySelector('.date_preorder');
    if (kitDates) {
      const dates = Array.from(document.querySelectorAll('.color_handle_ps'))
        .map((el) => el.dataset.preorderdate)
        .filter(Boolean);
      kitDates.innerHTML = dates.length ? dates.join(', ') : '';
    }
  }

  _refreshAddToCartAvailability() {
    const colorHandleParents = document.querySelectorAll('.color_handle_ps');
    const button = this.addToCartButton;
    let disableButton = false;
    colorHandleParents.forEach((parent) => {
      if (parent.dataset.colorSelected !== 'true') {
        disableButton = true;
      }
    });
    if (disableButton) {
      button.setAttribute('custom-disable', 'true');
      button.classList.add('disabled2');
    } else {
      button.removeAttribute('custom-disable');
      button.classList.remove('disabled2');
    }
  }

  _updateTotalPrice() {
    this.totalPrice = 0;
    Object.values(this.components).forEach((component) => {
      this.totalPrice = this.totalPrice + (component.price * component.qty);
    });
    this.discountValue = 1 - (this.discount / 100);
    this.priceElements.forEach((el) => {
      el.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00 * this.discountValue).toFixed(2));
    });
    this.unitPriceElements.forEach((el) => {
      el.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', ((this.totalPrice  / 100.00 * this.discountValue) / this.components["mesh"].qty).toFixed(2));
    });

    if(this.discount > 0) {
      this.originalPriceElements.forEach((el) => {
        el.classList.add('visible');
        this.priceOriginal = el.querySelector('[data-price-original]');
        this.priceCompare = el.querySelector('[data-price-compare]');
        if(this.priceOriginal) this.priceOriginal.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00).toFixed(2));
        if(this.priceCompare) this.priceCompare.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00).toFixed(2));
      });
      this.originalUnitPrices.forEach((el) => {
        el.classList.add('visible');
        const regular = el.querySelector('[data-unit-price-regular]');
        if (regular) regular.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', ((this.totalPrice / 100.00) / this.components["mesh"].qty).toFixed(2));
      });
    }
  }
  
  _updateMeshCards(selector, color) {
    this.cards = document.querySelectorAll(`.kit-summary__product:not(.hidden)${selector}`);
    if(!this.cards) return;
    this.cards.forEach((card) => {
      card.style.display = 'flex';
      //this.variantImage = variant.featured_image;
      //if(this.variantImage) this.updateImageSrc(card.querySelector('.kit-summary__image--wrapper img'), `${this.variantImage.src}&width=800`);
      card.querySelector('.kit-builder__swatch').style.background = `var(--${color(' ', '')})`;
      card.querySelector('.kit-summary__line-item--colour span').innerHTML = `<span>${color}<sup>®</sup></span>`;
    });
    
    setTimeout(() => {
      //setLoadingState(false);
    }, 1000);
  }

  _updateProductCards(selector, variant) {
    this.cards = document.querySelectorAll(`.kit-summary__product:not(.hidden)${selector}`);
    if(!this.cards) return;
    this.cards.forEach((card) => {
      card.style.display = 'flex';
      this.variantImage = variant.featured_image;
      if(this.variantImage) this.updateImageSrc(card.querySelector('.kit-summary__image--wrapper img'), `${this.variantImage.src}&width=800`);
      card.querySelector('.kit-builder__swatch').style.background = `var(--${variant.title.replace(' ', '')})`;
      card.querySelector('.kit-summary__line-item--colour span').innerHTML = `<span>${variant.title}<sup>®</sup></span>`;
    });
    
    setTimeout(() => {
      // setLoadingState(false);
    }, 1000);
  }

  updateImageSrc(imageElement, newImageUrl) {
    this.tempImage = new Image();
    this.tempImage.onload = () => {
      imageElement.src = newImageUrl;
      imageElement.srcset = this.tempImage.srcset;
    };
    this.tempImage.src = newImageUrl;
  }

  _handleAddToCart(e, button) {
    e.preventDefault();
    button.classList.add('processing');
    button.disabled = true;
    let bundleId = Date.now();
    let formData = {
      items: [],
      attributes: {}
    };

    // Check the live, currently-selected colours for preorder status rather than
    // relying on the preorder state that was computed once at page load — mesh
    // width and trim type changes swap the underlying product, so this must be
    // re-evaluated per selected colour, not fixed at render time.
    const preOrderElements = document.querySelectorAll('.activeme');
    const isPreOrder = preOrderElements.length > 0;

    for (let componentName in this.components) {
      let component = this.components[componentName];
      if (component.handle) {
        let item = {
          id: component.id,
          quantity: component.qty,
          properties: {
            _bundleName: this.kitName,
            _retailDiscount: this.retailDiscount,
            _tradeDiscount: this.tradeDiscount,
            _wholesaleDiscount: this.wholesaleDiscount,
            _kitQuantity: this.components['mesh'].quantity,
          }
        };
        item.properties['_bundleId'] = bundleId;
        item.properties['Kit name'] = this.kitName;
        if(this.internalOrdering) {

          // item.properties['_internalOrder'] = "true";
        }

        if (component.screwType) {
          // item.properties['Screw type'] = component.screwType;
        }

        preOrderElements.forEach(preOrderElement => {
          let parentProduct = preOrderElement.closest('.color_handle_ps');
          if (parentProduct && parentProduct.getAttribute('data-product-handle') === component.handle) {
            let preOrderMessage = preOrderElement.querySelector('.kit_simplemsg')?.textContent.trim() || "true";
            preOrderMessage = preOrderMessage.replace(/^Pre-Order - /i, '');
            item.properties['Pre-order'] = preOrderMessage;
          }
        });

        formData.items.push(item);
      }
    }

    if (isPreOrder) {
      formData.attributes['Pre order'] = "true";
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      console.log(response.status, response.message)
      if (response.status === 422) {
        this._onError(response.description);
      } else {
        this._onSuccess();
      }
      button.classList.remove('processing');
      button.disabled = false;
    })
    .catch((error) => {
      console.log(error)
      this._onError(error.description);
    });
  }

  _onSuccess() {
    return fetch(`${window.Theme.routes.cart_url}.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (!response.ok) {
        return Promise.reject(response);
      }

      return response.json();
    }).then(data => {
      location.href = window.Theme.routes.cart_url;
    }).catch(error => {
      this._showErrorBanner(error.message);
    });
  }

  _showErrorBanner(errorMsg) {
    this.messageBanner = new MessageBanner(errorMsg, 'error');
  }

  _onError(description) {
    const regex = /'([^']+)'/;
    const match = description.match(regex);
    const extractedText = match ? match[1] : null;
    this.errorContainer = document.createElement('div');
    const productTitle = description.split("'")[1];
    this.errorContainer.innerText = `Not enough ${productTitle} left in stock. Contact us for a timeframe on resupply or recommendations on alternative colours.`
    this.querySelector('.error-container').append(this.errorContainer);
  }
}

if(!window.customElements.get('kit-builder-form')) {
  window.customElements.define('kit-builder-form', KitBuilderForm);
}

class ProductMeshSize extends HTMLElement {
  constructor() {
    super();
    this.widthOptions = this.querySelectorAll('[data-size-option]');
    if(this.widthOptions) {
      this.widthOptions.forEach((option) => {
        option.addEventListener('click', () => this._handleSizeSelection(option));
      })
    }

    this.helperOverlay = document.querySelector('[data-helper-overlay]');
    this.helperLink = this.querySelector('[data-helper-link]');
    this.helperLink.addEventListener('click', () => this._handleHelperOverlay());
  }

  _handleColorReset() {
    this.colorElement = document.querySelector('[data-type="mesh"]');
    this.swatch = this.colorElement.querySelector('.kit-product__swatch');
    if(this.swatch) {
      this.swatch.classList.add('placeholder');
      this.swatch.style.background = `transparent`;
    }
    this.colorName = this.colorElement.querySelector('.kit-summary__line-item--colour');
    if(this.colorName)this.colorName.innerHTML = `Please reselect your mesh colour`;
    this.form.addToCartButton.classList.add('disabled');
  }

  // Solar kits have no colour-choice UI (it's hidden), so mesh width is the only
  // thing that determines the preorder status of the mesh line item — refresh it
  // directly from the selected width option instead of waiting on a colour pick.
  _refreshPreorderForOption(option) {
    const preorder = option.dataset.preorder;
    const preorderdate = option.dataset.preorderdate;
    const colorElement = document.querySelector('[data-type="mesh"]');
    if (!colorElement) return;
    const preOrderMsg = colorElement.querySelector('.kit-summary__line-item--pre-order .kit_simplemsg');
    const preOrderWrapper = colorElement.querySelector('.kit-summary__line-item--pre-order');
    if (preOrderWrapper && preOrderMsg) {
      if (preorder == 'true') {
        preOrderWrapper.classList.add('activeme');
        preOrderMsg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${preorderdate}`;
      } else {
        preOrderWrapper.classList.remove('activeme');
        preOrderMsg.innerHTML = ``;
      }
    }

    colorElement.dataset.preorderdate = preorder == 'true' ? preorderdate : '';

    this.form._refreshPreorderMessaging();
  }

  _handleHelperOverlay() {
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500);
    this.closeButton = this.helperOverlay.querySelector('.kit-builder__helper--close');
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.helperOverlay.style.display = 'none';
    })
  }

  _handleSizeSelection(option) {
    this.widthOptions.forEach((option) => option.classList.remove('active'));
    option.classList.add('active');
    
    this.productTitle = option.dataset.title;
    this.meshColor = document.querySelector('mesh-product-color');
    this.meshColor.setProductTitle(this.productTitle);
    
    this.form = document.querySelector('kit-builder-form');
    this.productHandle = option.dataset.productHandle;
    this.productPrice = parseInt(option.dataset.productPrice);
    this.variantId = option.dataset.variantId;
    this.meshColor.dataset.productHandle = this.productHandle;
    this.form.setProduct('mesh', 'handle', this.productHandle);
    this.form.setProduct('mesh', 'price', this.productPrice);
    this.form.setProduct('mesh', 'id', this.variantId);

    this.form._updateTotalPrice();

    this.meshProducts = document.querySelectorAll('[data-mesh-product]');
    if(this.meshProducts) {
      this.meshProducts.forEach((product) => {
        product.style.opacity = 0;
        product.style.pointerEvents = 'none';
        if(product.dataset.productHandle == this.productHandle) {
          product.style.opacity = 1;
          product.style.pointerEvents = 'all';
        }
      })
    }

    this._refreshPreorderForOption(option);

  }
}

if(!window.customElements.get('product-mesh-size')) {
  window.customElements.define('product-mesh-size', ProductMeshSize);
}

class ProductTrimChoice extends HTMLElement {
  constructor() {
    super();
    this.trimOptions = this.querySelectorAll('[data-type-option]');
    if(this.trimOptions) {
      this.trimOptions.forEach((option) => {
        option.addEventListener('click', () => this._handleTypeSelection(option));
      })
    }
  }

  _handleColorReset() {
    this.colorElement = document.querySelector('[data-type="trim"]');
    this.swatch = this.colorElement.querySelector('.kit-product__swatch');
    if(this.swatch) {
      this.swatch.classList.add('placeholder');
      this.swatch.style.background = `transparent`;
    }
    this.colorName = this.colorElement.querySelector('.kit-summary__line-item--colour');
    if(this.colorName)this.colorName.innerHTML = `Please reselect your trim colour`;
    this.form.addToCartButton.classList.add('disabled');
  }

  // Solar kits have no colour-choice UI (it's hidden), so trim type is the only
  // thing that determines the preorder status of the trim line item — refresh it
  // directly from the selected type option instead of waiting on a colour pick.
  _refreshPreorderForOption(option) {
    const preorder = option.dataset.preorder;
    const preorderdate = option.dataset.preorderdate;
    const colorElement = document.querySelector('[data-type="trim"]');
    if (!colorElement) return;
    const preOrderMsg = colorElement.querySelector('.kit-summary__line-item--pre-order .kit_simplemsg');
    const preOrderWrapper = colorElement.querySelector('.kit-summary__line-item--pre-order');
    if (preOrderWrapper && preOrderMsg) {
      if (preorder == 'true') {
        preOrderWrapper.classList.add('activeme');
        preOrderMsg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${preorderdate}`;
      } else {
        preOrderWrapper.classList.remove('activeme');
        preOrderMsg.innerHTML = ``;
      }
    }

    colorElement.dataset.preorderdate = preorder == 'true' ? preorderdate : '';

    this.form._refreshPreorderMessaging();
  }

  _handleTypeSelection(option) {
    this.trimOptions.forEach((option) => option.classList.remove('active'));
    option.classList.add('active');
    
    this.productTitle = option.dataset.title;
    this.trimColor = document.querySelector('trim-product-color');
    this.trimColor.setProductTitle(this.productTitle);
    
    this.form = document.querySelector('kit-builder-form');
    this.productHandle = option.dataset.productHandle;
    this.productPrice = parseInt(option.dataset.productPrice);
    this.variantId = option.dataset.variantId;
    this.trimColor.dataset.productHandle = this.productHandle;
    this.form.setProduct('trim', 'handle', this.productHandle);
    this.form.setProduct('trim', 'price', this.productPrice);
    this.form.setProduct('trim', 'id', this.variantId);

    this.form._updateTotalPrice();

    this.trimProducts = document.querySelectorAll('[data-trim-product]');

    if(this.trimProducts) {
      this.trimProducts.forEach((product) => {
        product.style.display = 'none';
        product.classList.add('hidden');
        if(product.dataset.productHandle == this.productHandle) {
          product.style.display = 'flex';
          product.classList.remove('hidden');
        }
      })
    }

    this._refreshPreorderForOption(option);
  }
}

if(!window.customElements.get('product-trim-choice')) {
  window.customElements.define('product-trim-choice', ProductTrimChoice);
}

class ColorChoice extends HTMLElement {
  constructor() {
    super();
    this.colorOverlay = document.querySelector('[data-color-overlay]');
    this.context = this.dataset.type;
    this.form = document.querySelector('kit-builder-form');
  
    this.currentProductColors = this.colorOverlay.querySelector('[data-product-colors-placeholder]');
    this.closeButton = this.colorOverlay.querySelector('.kit-builder__screw--close');
    
    this.colorOptions = document.querySelectorAll(`[data-color-option="${this.context}"]`);
    if(this.colorOptions.length) {
      this.colorOptions.forEach((option) => option.addEventListener('click', () => this._handleOptionClick())); 
    } 

    this.addToCartButton = this.form.addToCartButton;
  }

  _handleHelperText(show) {
    if(show) {
      this.helperText.style.display = 'block';
      setTimeout(() => {
        this.helperText.style.opacity = '1';
      }, 200)
    } else {
      this.helperText.style.opacity = '0';
      
      setTimeout(() => {
        this.helperText.style.display = 'none';
      }, 200)
    }
  }

  _handleOptionClick() {
    this._initOverlay();
  }

  _initOverlay() {
    this.handle = this.dataset.productHandle;
    fetch(`/products/${this.handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
        const productSection = doc.querySelector('[data-product-wrapper]');
        const productColors = productSection.querySelector('[data-product-colors]')
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
        this.product = this.productSettings.product;
  
        if(this.currentProductColors && productColors) {
          this.currentProductColors.innerHTML = productColors.outerHTML;
        }

        this.productTitle = this.product.title;
        this.productTitleEl = document.querySelector('[data-overlay-heading]');
        this.productTitlePlaceholder = this.productTitleEl.dataset.text;
        this.productTitleEl.innerText = this.productTitlePlaceholder.replace('||product_title||', this.productTitle);

              
        this.helperText = this.colorOverlay.querySelector('[data-screw-color-helper]');
        this.helperLink = this.colorOverlay.querySelector('[data-helper-link]');
        if(this.helperLink) this.helperLink.addEventListener('click', () => this._handleHelperText(true));
        this.helperTextClose = this.colorOverlay.querySelector('.kit-builder__screw-helper--close');
        if(this.helperTextClose) this.helperTextClose.addEventListener('click', () => this._handleHelperText(false));
        
        this.preSelectedColor = this.form.fetchPreselectedColor(`${this.context}`);
        
        if(this.preSelectedColor){
          this.initialSlide = this.colorOverlay.querySelector(`input[data-variant-title="${this.preSelectedColor}"]`);
          if(this.initialSlide) { 
            this.initialIndex = this.initialSlide.dataset.index;
          } else {
            this.initialIndex = 0;
          }
        } else {
          this.initialIndex = 0;
        }
       
        this.show(this.initialIndex);
      })
      .catch(error => {
        console.error('Error fetching product:', error);
      })

    this.closeButton.addEventListener('click', () => {
      this.colorOverlay.style.display = 'none';
      this.productColours.destroy(true, true);
    })
  }

  show(index) {
    this.colorOverlay.style.display = 'flex';
    this.colorOverlay.style.opacity = '0';
    this._initSliders(this.handle, index);
    this._initSliderViewButtons(this.handle)
    setTimeout(() => {
      this.colorOverlay.style.opacity = '1';
    }, 500);
  }

  _initSliders(handle, index) {
    // Initialize Swiper
    this.slider = this.colorOverlay.querySelector(`#color-carousel--${handle}`);
    this.slider.classList.add(`slider--${this.context}`);
    this.productColours = new Swiper(`.slider--${this.context}`, {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      pagination: {
        el: `.swiper-pagination--${handle}`,
        type: "progressbar",
      },
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 80,
        modifier: 1,
        scale: 0.85,
        slideShadows: false,
      },
      breakpointsBase: 'window',
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });
    this.productColours.on('transitionEnd', (event) => this._handleSliderChange(event.realIndex));
    this.productColours.slideTo(index, 10);
    this._handleSliderChange(index);

  }

  _initSliderViewButtons(handle) {
    this.gridView = this.colorOverlay.querySelector('[data-grid-view]');
    this.sliderView = this.colorOverlay.querySelector('[data-slider-view]');
    this.colours = this.colorOverlay.querySelector('color-selector');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this.productColours.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
        this.colorSwatches = this.colorOverlay.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', () => {
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            this._handleSliderChange(index);
            swatch.classList.add('swiper-slide-active');
          }));
        }
      }
    })

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this._initSliders(handle);
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _handleSliderChange(index) {
    const swatchElement = this.colorOverlay.querySelector(`#variant-swatch-${index}`);
    if (swatchElement) {
      setTimeout(() => {
        this.selectedInput = swatchElement.querySelector('.options-selection__option-value-input');
        this.variantHandle = this.selectedInput.dataset.variantHandle;
        this.variantTitle = this.selectedInput.dataset.variantTitle;
        this.productHandle = this.selectedInput.dataset.product;
        this.variantId = this.selectedInput.value;
        this.isAvailable = this.selectedInput.dataset.variantOptionAvailable;
        this.variantPreorder = this.selectedInput.dataset.preorder;
        this.variantPreorderDate = this.selectedInput.dataset.preorderdate;
        this._handleButtonUpdate(this.variantTitle, this.variantId, this.productHandle, this.isAvailable, this.variantPreorder, this.variantPreorderDate);
      }, 200);
    }
  }

  _handleButtonUpdate(title, id, handle, available, preorder, preorderdate) {
    this.nextButton = this.colorOverlay.querySelector('[data-choose-color]');
    let pre_orderoption = false;
    if (preorder == 'true') {
      pre_orderoption = true;
    } else if (available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }
    this.nextButton.innerText = `Choose ${title}`;
    this.nextButton.classList.remove('disabled');

    // Remove existing event listener if it exists
    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
    }

    // Setup event listener for nextButton
    this.nextButtonListener = (event) => {
      let type;
      if(this.context == 'saddles') {
        type = 'saddle';
      } else {
        type = this.context;
      }
      event.preventDefault();
      fetch(`/products/${handle}?view=kit-product`).then(response => response.text())
        .then(product => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(product, 'text/html');

          const staticProduct = doc.querySelector('[data-section-type="static-product"]');
          this.productSettings = JSON.parse(staticProduct.innerHTML);
          this.product = this.productSettings.product;
          this.variant = this.product.variants.find(variant => variant.title == title);
          this.form.updateVariant(this.context, id, handle, title);
          this.form._updateProductCards(`[data-${type}-product]`, this.variant)
          this.screwHandle = this.dataset.screwHandle
          if(this.screwHandle) this._setScrewColor(this.screwHandle, title, type);
          this.colorOverlay.style.display = 'none';
          this._updateColor(title, pre_orderoption, preorderdate);
          this.productColours.destroy(true, true);
          this.addToCartButton.classList.remove('disabled');
        })
        .catch()
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }

  _setScrewColor(handle, color, type) {
    fetch(`/products/${handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
  
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
        this.product = this.productSettings.product;
        this.variant = this.product.variants.find(variant => variant.title == color);
        if(this.variant) {
          this.form.setProduct(`${type}Screws`, 'price', this.variant.price);
          this.form.updateVariant(`${type}Screws`, this.variant.id, handle, color);
          this.form._updateProductCards(`[data-${type}-screw-product]`, this.variant)
        }
        this.form._updateTotalPrice();
      })
      .catch()
  }
  
  _updateColor(color, pre_orderoption, preorderdate) {
    this.swatch = this.querySelector('.kit-product__swatch');
    if(this.swatch) {
      this.swatch.classList.remove('placeholder');
      this.swatch.style.background = `var(--${color.replace(/\s/g, '')})`;
    }
    this.colorName = this.querySelector('.kit-summary__line-item--colour');
    if(this.colorName)this.colorName.innerHTML = `${color}<sup>®</sup>`;

    this.preOders = this.querySelector('.kit-summary__line-item--pre-order .kit_simplemsg');
    this.preOdersp = this.querySelector('.kit-summary__line-item--pre-order');
    if (this.preOders) {
      if (pre_orderoption == true) {
        this.preOdersp.classList.add('activeme');
        this.preOders.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${preorderdate}`;
      } else {
        this.preOdersp.classList.remove('activeme');
        this.preOders.innerHTML = ``;
      }
    }

    this.dataset.preorderdate = pre_orderoption == true ? preorderdate : '';

    this.dataset.colorSelected = 'true';
    setTimeout(() => this.form._refreshPreorderMessaging(), 200);
    setTimeout(() => this.form._refreshAddToCartAvailability(), 250);
  }

}

if(!window.customElements.get('color-choice')) {
  window.customElements.define('color-choice', ColorChoice);
}

class MeshProductColor extends ColorChoice {
  constructor() {
    super();
  }

  setProductTitle(title) {
    this.querySelector('[data-title-placeholder]').innerText = title;
  }
}

if(!window.customElements.get('mesh-product-color')) {
  window.customElements.define('mesh-product-color', MeshProductColor);
}

class SaddleProductColor extends ColorChoice {
  constructor() {
    super();
  }
}

if(!window.customElements.get('saddle-product-color')) {
  window.customElements.define('saddle-product-color', SaddleProductColor);
}

class TrimProductColor extends ColorChoice {
  constructor() {
    super();
  }

  setProductTitle(title) {
    this.querySelector('[data-title-placeholder]').innerText = title;
  }
}

if(!window.customElements.get('trim-product-color')) {
  window.customElements.define('trim-product-color', TrimProductColor);
}

class KitProductQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.field = this.querySelector('[data-quantity-selector]');
    this.input = this.querySelector('[data-quantity-input]');
    this.plus = this.querySelector('[data-quantity-plus]');
    this.minus = this.querySelector('[data-quantity-minus]');
    this.minusButtonWrapper = this.querySelector('[data-button-wrapper-minus]');
    this.incrementValue = parseInt(this.input.dataset.incrementValue, 10);
    this.increaseAmount = this.increaseAmount.bind(this);
    this.decreaseAmount = this.decreaseAmount.bind(this);
    this.onChange = kitDebounce((e) => this.onChange(e));
    this.meshSize = document.querySelector('mesh-size-section');
    this.form = document.querySelector('kit-builder-form');
    this.registerEvents();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      const initialQuantity = parseInt(Math.round(this._getCount() / 10) * 10);
      this._updateSummary(initialQuantity);
    });
  }

  registerEvents() {
    this.plus.addEventListener('click', (e) => this.increaseAmount(e));
    this.minus.addEventListener('click', (e) => this.decreaseAmount(e));
    this.input.addEventListener('change', (e) => this.setAmount(e));
    this.input.addEventListener('keyup', (e) => this.quantityKeyUp(e));
    this.input.addEventListener('keydown', (e) => this.quantityKeyDown(e));

    this._updateMinusButton();
  }

  setAmount(e) {
    e.preventDefault();
    let count = Math.round(this._getCount() / 30) * 30;
    if (!count) {
      count = this.incrementValue;
    }
    this.input.value = count;
    this._updateMinusButton();
    this.onChange(e);
    this._updateSummary(count);
}

  _getCount() {
    return this.input.valueAsNumber;
  }

  increaseAmount(e) {
    e.preventDefault();
    let count = this._getCount();
    this.input.value = count + this.incrementValue;
    this._updateMinusButton();
    this.onChange(e.currentTarget);
    this._updateSummary(this.input.value);
  }

  decreaseAmount(e) {
    e.preventDefault();
    let count = this._getCount();
    this.input.value = count - this.incrementValue;
    this._updateMinusButton();
    this.onChange(e.currentTarget);
    this._updateSummary(this.input.value);
  }

  quantityKeyUp(e) {
    if (e.key === 'Backspace') {
      return;
    }
    this._updateMinusButton();
    this.onChange(e.currentTarget);
  }

  quantityKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  _updateMinusButton() {
    const count = this._getCount();
    if (count <= this.incrementValue) {
      this.minusButtonWrapper.classList.add('quantity-selector__button-wrapper--disabled');
    } else {
      this.minusButtonWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
    }
  }

  _updateSummary(count) {
    if(this.form) {
      this.form.handleQtyChange(parseInt(count));
    }
  }

  unload() {
    this.events.unregisterAll();
  }
}

if (!window.customElements.get('kit-product-quantity-selector')) {
  window.customElements.define('kit-product-quantity-selector', KitProductQuantitySelector);
}